// Shared Utilities - Re-export all utility functions

export {
    isValidEmail,
    validateEmail,
    validateNumber
} from './validation.js';

export {
    prefersReducedMotion,
    debounce,
    escapeHtml
} from './dom.js';

export {
    formatDate,
    formatDateOnly,
    formatDateTime,
    formatTimeAgo,
    formatCurrency,
    formatFeatureName,
    formatFeatureValue
} from './format.js';
